var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 2,
    viewBox: "0 0 48 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 1H48",
    stroke: "black",
    strokeOpacity: 0.9,
    strokeDasharray: "4 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.6fba9b43d795ea9f7905e6971c2b56e3.svg";
export { ForwardRef as ReactComponent };